import { render, staticRenderFns } from "./AffirmHeader.vue?vue&type=template&id=6e20b08d&"
import script from "./AffirmHeader.vue?vue&type=script&lang=js&"
export * from "./AffirmHeader.vue?vue&type=script&lang=js&"
import style0 from "./AffirmHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports